import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import type { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { SupplierManagementHelperService } from '../../../core/services/supplier-management-helper.service';
import { getFormData } from '../../../shared/helpers/utilities.helper';
import type { DeleteParameters } from '../../../shared/models/delete-parameters.models';
// eslint-disable-next-line unicorn/prevent-abbreviations -- TODO: delete the comment and fix the error
import type { IRequestParams } from '../../../shared/models/request-parameters.models';
import type { ApiResponse } from '../../../shared/models/response';
import type { Account, DeleteAccountConfig } from '../models/account.models';
import type {
  AccountsCollectionApiResponseDto,
  AccountUsersLimitsApiResponseDto,
} from '../models/accounts.dto.models';

@Injectable({
  providedIn: 'root',
})
export class AccountService {
  readonly #http = inject(HttpClient);
  readonly #supplierManagementHelper = inject(SupplierManagementHelperService);

  getAccounts(
    config: IRequestParams | object,
  ): Observable<AccountsCollectionApiResponseDto> {
    const queryString = this.#supplierManagementHelper.getFilterAsQuerystring(
      config,
      null,
      ['company_id'],
    );
    return this.#http.get<AccountsCollectionApiResponseDto>(
      `${environment.api.endpoint}/accounts?${queryString}`,
    );
  }

  getFilteredAccounts(config: DeleteAccountConfig): Observable<ApiResponse> {
    const queryString = this.#supplierManagementHelper.getFilterAsQuerystring({
      ...config,
      relations: ['addresses'],
    });

    return this.#http.get<ApiResponse>(
      `${environment.api.endpoint}/accounts?${queryString}`,
    );
  }

  getAccount(id: number): Observable<ApiResponse> {
    return this.#http.get<ApiResponse>(
      `${environment.api.endpoint}/account/${id}`,
    );
  }

  updateAccount(account: Account): Observable<ApiResponse> {
    const formData = getFormData(account);
    return this.#http.post<ApiResponse>(
      `${environment.api.endpoint}/account/${account.id}`,
      formData,
    );
  }

  createAccount(account: Account): Observable<ApiResponse> {
    const formData = getFormData(account);

    return this.#http.post<ApiResponse>(
      `${environment.api.endpoint}/account/store`,
      formData,
    );
  }

  deleteAccount(parameters: DeleteParameters): Observable<ApiResponse> {
    let url = `${environment.api.endpoint}/account/${parameters.id}?type=${parameters.type}`;
    if (parameters.newId !== undefined) {
      url = `${url}&new_id=${parameters.newId}`;
    }

    return this.#http.delete<ApiResponse>(url);
  }

  getUsersLimit(config: {
    id: number;
  }): Observable<AccountUsersLimitsApiResponseDto> {
    return this.#http.get<AccountUsersLimitsApiResponseDto>(
      `${environment.api.endpoint}/account/userLimit/${config.id}`,
    );
  }
}
